module.exports = ".popup {\n  /*background-color: #2798d8;*/\n  background-image: url(img/linescape-pop-up-background.jpg);\n  width: 400px;\n  max-width: 100%; }\n\np,\nlabel {\n  color: #ffffff;\n  line-height: 24px; }\n\nh5 {\n  color: #ffffff;\n  font-weight: 500;\n  margin-bottom: 10px; }\n\n.btn {\n  width: initial;\n  padding-left: 20px;\n  padding-right: 20px; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/arrival-message/arrival-message.component.scss
// module id = 921
// module chunks = 0